import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {Button, Container, Form} from "react-bootstrap";

//Img
import imgDCSIPeople from "../../../../assets/image/addProducts/imgDSCIPeople.png";

//Services
import { deliveriesServices } from "../../../../helpers/services/DeliveriesServices";

//Enum
import { ResponseStatusEnum } from "../../../../helpers/GlobalEnum";
import AlertComponent from "../../../../helpers/alert/AlertComponent";
import {FaSave, FaStepBackward} from "react-icons/fa";
import { Loading } from "../../shared/loading/Loading";
import { SmartTable } from "../../../../shared/ui/smart-table";

//Opciones para los productos a entregar
const deliveryStatus = [
    { id: 0, label: "NO ENTREGADO" },
    { id: 1, label: "ENTREGADO" },
    //{ id: 2, label: "PENDIENTE POR ENTREGAR" },
    { id: 3, label: "ENTREGA PARCIAL" }
];

export const EditDeliveryOrder = () => {

    const params = useParams();
    const navigate = useNavigate();

    const deliverId =  params.id;
    const [listDeliveryProducts, setListDeliveryProducts] = useState([]);
    const [deliveryId, setDeliveryId] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);

    const columns = [
        { title: "COD", dataIndex: "id", key: "id", width: 100 },
        {
            title: "NOMBRE",
            dataIndex: "name",
            key: "name",
            width: 260,
            render: (value) => (
                <div
                    style={{
                        textAlign: "left",
                        whiteSpace: "normal",
                        overflow: "visible",
                    }}
                >
                    {value}
                </div>
            ),
        },
        {
            title: "DESCRIPCIÓN",
            dataIndex: "description",
            key: "description",
            width: 420,
            render: (value) => (
                <div
                    style={{
                        textAlign: "left",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        overflow: "visible",
                    }}
                >
                    {value}
                </div>
            ),
        },
        { title: "CANT. SOLICITADA", dataIndex: "amount", key: "amount", width: 160 },
        {
            title: "CANT. A ENTREGAR",
            dataIndex: "quantityToBeDelivered",
            key: "quantityToBeDelivered",
            width: 180,
            render: (_value, record) => {
                if (!record) {
                    console.warn("render: fila vacía en quantityToBeDelivered");
                    return "–";
                }
                return (
                    <Form.Control
                        type="number"
                        className="small-input form-control-sm"
                        value={record.quantityToBeDelivered ?? 0}
                        min="0"
                        onChange={(e) =>
                            handleQuantityChange(record.id, e.target.value)
                        }
                        style={{
                            width: "100%",
                            padding: "5px",
                            fontSize: "14px",
                            cursor: "pointer",
                        }}
                    />
                );
            },
        },
        {
            title: "ESTADO",
            dataIndex: "state",
            key: "state",
            width: 180,
            render: (_value, record) => {
                return (
                    <select
                        value={record.state}
                        onChange={(e) =>
                            handleStatusChange(record.id, parseInt(e.target.value))
                        }
                        style={{
                            width: "100%",
                            padding: "5px",
                            fontSize: "14px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            backgroundColor: "white",
                            cursor: "pointer",
                        }}
                    >
                        {deliveryStatus.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                );
            },
        },
    ];

    //
    const getDeliveryById = async (id) => {
        setIsLoading(true);
        try {
            const {data, status} = await deliveriesServices.getProductsFromDelivery(id);
            if (status === ResponseStatusEnum.OK) {
                const normalized = normalizeRows(data?.items);
                setDeliveryId(data?.cub?.id);
                setListDeliveryProducts(normalized);
            }
        } catch (error) {
            console.error("Error fetching deliveries:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const normalizeRows = (data) => {
        return data.map((row, index) => {
            try {
                return {
                    id: Number(row?.id),
                    name: row?.producto?.nombre || "Sin nombre",
                    description: row?.producto?.especificacion_tecnicas || "Sin descripción",
                    amount: Number(row?.cantidad) || 0,
                    quantityToBeDelivered: row?.quantityToDeliver !== undefined
                        ? Number(row.quantityToDeliver)
                        : Number(row?.cantidad),
                    state: Number(row?.estado) ?? 0,
                    price: parseFloat(row?.valor_final) || 0,
                };
            } catch (error) {
                console.error(`Error procesando fila en index ${index}:`, row, error);
                return { id: index, name: "Error", description: "Error en los datos", amount: 0, quantityToBeDelivered: 0, state: 0, price: 0 };
            }
        });
    };

    //
    const handleQuantityChange = (id, value) => {
        const newProducts = listDeliveryProducts.map((product) => {
            if (product.id === id) {
                return { ...product, quantityToBeDelivered: value.trim() === '' ? '' : Math.max(0, Number(value)) };
            }
            return product;
        });
        setListDeliveryProducts(newProducts);
    };

    //
    const handleStatusChange = (id, value) => {
        const newProducts = listDeliveryProducts.map((product) => {
            if (product.id === id) {
                return { ...product, state: value };
            }
            return product;
        });
        setListDeliveryProducts(newProducts);
    };

    //
    const handleSaveProduct = async () => {
        const hasProductsWithInvalidState = listDeliveryProducts.every(prod => prod?.state === 0);

        if (hasProductsWithInvalidState) {
            showError('Error', 'No puedes poner todos los productos en estado de "No entregado".');
            return;
        }

        try {
            setIsLoading(true);
            const dataSaveProducts = listDeliveryProducts.map(prod => ({
                id: prod?.id,
                cantidad: prod?.quantityToBeDelivered,
                estado: prod?.state
            }));

            const {data, status} = await deliveriesServices.editDelivery(deliverId, dataSaveProducts);
            if(status === ResponseStatusEnum.OK) {
                showAlert('Éxito', 'Producto actualizado correctamente.')
                navigate(`/admin/deliveries/${deliveryId}`)
            }

            if(status === ResponseStatusEnum.BAD_REQUEST) {
                showError('Error', `${data?.errores[0]?.mensaje} con id: ${data?.errores[0]?.id}`);
            }
        } catch (error) {
            showError('Error al guardar los productos', `${error}`);
        } finally {
            setIsLoading(false);
        }
    };

    //
    const showAlert = (title, message) => {
        AlertComponent.success(title, message);
    };

    //
    const showError = (title, message) => {
        AlertComponent.error(title, message);
    };

    const handleBack = () => {
        navigate(`/admin/deliveries/${deliveryId}`)
    }

    useEffect(() => {
        if (params.id) {
            getDeliveryById(params.id);
        }
    }, []);

    return (
        <>
            <div className="main-container">
                <div className="header-image position-relative">
                    <img src={imgDCSIPeople} alt="Fondo" className="background-image w-100" />
                    <div className="overlay-text position-absolute w-100 text-center">
                        <h1>¡Editar entrega de productos!</h1>
                    </div>
                </div>

                {isLoading && <Loading text="Editando productos..." />}

                <div className="p-5">
                    <Container>

                        <SmartTable
                            rowKey="id"
                            columns={columns}
                            dataSource={listDeliveryProducts}
                            loading={isLoading}
                            total={listDeliveryProducts.length}
                            currentPage={page}
                            defaultPageSize={pageSize}
                            pageSizeOptions={["5", "10", "20"]}
                            onPageChange={(nextPage, nextPageSize) => {
                                setPage(nextPage);
                                setPageSize(nextPageSize);
                            }}
                            defaultText="---"
                            emptyText="No hay productos para editar."
                            enableRowSelection={false}
                            showToolbar={false}
                            showTableResize={false}
                            showColumnSettings={false}
                            scroll={{ x: 1400 }}
                        />

                        <div className="button-container mt-2 d-flex flex-md-row flex-column justify-content-md-end justify-content-center">
                            <Button
                                variant="outline-secondary"
                                onClick={handleBack}
                                className="responsive-button btn-action-back mb-2 mb-md-0"
                            >
                                <FaStepBackward /> ATRÁS
                            </Button>

                            <Button
                                variant="outline-success"
                                onClick={handleSaveProduct}
                                className="responsive-button"
                            >
                                <FaSave /> EDITAR ENTREGA
                            </Button>
                        </div>

                    </Container>
                </div>

            </div>
        </>
    )

}

